export enum TicketType {
    DUVIDA = "Dúvida",
    BUGFIX_lower = "Bugfix - BUG Produto",
    BUGFIX_upper = "BUGFIX - BUG Produto",
    MELHORIA = "Melhoria",
    MAPEAMENTO_PLANILHA = "Service - Criação Layout / Mapeamento Documento"
}
